import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';

@Component({
  selector: 'app-redirect-timer',
  templateUrl: './redirect-timer.component.html',
  styleUrls: ['./redirect-timer.component.scss'],
  imports: [MatIconModule, MatButtonModule],
})
export class RedirectTimerComponent implements OnInit, OnDestroy {
  private router = inject(Router);

  // /**
  //  * Defines the destination to redirect to.
  //  * @type {string}
  //  * @default ''
  //  * @example
  //  * // Redirect to login page
  //  * [destination]="'login'"
  //  */
  // @Input() destination = '';
  /**
   * Defines the duration of the timer in seconds.
   * @type {number}
   * @default 10
   * @example
   * // 20 second timer
   * [duration]="20"
   */
  @Input() duration = 10;
  destination = ''; // uncomment input destination above to support other routes
  redirectPageName = 'Landing';
  currentTimeout: ReturnType<typeof setTimeout>;

  ngOnInit(): void {
    const interval = setInterval(() => {
      this.duration--;
      if (this.duration === 0) {
        clearInterval(interval);
      }
    }, 1000);

    this.currentTimeout = setTimeout(() => {
      this.router.navigate([`/${this.destination}`]);
    }, this.duration * 1000);
  }

  ngOnDestroy(): void {
    clearTimeout(this.currentTimeout);
  }

  launchRedirect(): void {
    clearTimeout(this.currentTimeout);
    this.router.navigate([`/${this.destination}`]);
  }
}
